import React from 'react';
import { Link } from 'react-router-dom';
import MobileNav from './MobileNav';

const Header = () => {
  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Mobile Menu Button - Left */}
          <div className="flex items-center lg:hidden">
            <MobileNav />
          </div>

          {/* Logo - Center on mobile, Left on desktop */}
          <Link to="/" className="flex items-center space-x-2 lg:flex-initial flex-1 justify-center lg:justify-start">
            <img 
              src="https://customer-assets.emergentagent.com/job_discount-finder-55/artifacts/kl5rg4yh_ic_launcher.png" 
              alt="Peterhahn Fashion Coupon Club" 
              className="w-10 h-10 object-contain"
            />
            <span className="text-xl sm:text-2xl font-bold text-slate-900">
              Peterhahn Fashion Coupon Club
            </span>
          </Link>

          {/* Desktop Navigation - Hidden on mobile */}
          <nav className="hidden lg:flex items-center space-x-6">
            <Link to="/" className="text-slate-700 hover:text-slate-900 font-medium transition-colors">
              Home
            </Link>
            <Link to="/stores" className="text-slate-700 hover:text-slate-900 font-medium transition-colors">
              Stores
            </Link>
            <Link to="/about" className="text-slate-700 hover:text-slate-900 font-medium transition-colors">
              About
            </Link>
            <Link to="/contact" className="text-slate-700 hover:text-slate-900 font-medium transition-colors">
              Contact
            </Link>
          </nav>

          {/* Spacer for mobile to balance the layout */}
          <div className="w-10 lg:hidden"></div>
        </div>
      </div>
    </header>
  );
};

export default Header;
